/** "1 file", "3 files" — English count with a regular plural. */
export const formatCount = (count: number, noun: string): string => `${count} ${noun}${count === 1 ? '' : 's'}`
